import BaseCommand from "@/models/api/commands/BaseCommand";

export interface ImportAdvanceDocumentsCommandParams {
  DocumentIds: Array<string>;
  RecalculateAdvanceDocument: boolean; // false
}

export class ImportAdvanceDocumentsCommand extends BaseCommand {
  CommandName = "ImportAdvanceDocuments";
  Command: ImportAdvanceDocumentsCommandParams;
  constructor(sessionId: string, operationId: string, paymentDateParams: ImportAdvanceDocumentsCommandParams) {
    super(sessionId, operationId);
    this.Command = paymentDateParams;
  }
}
